// @flow
import React from 'react';
import _ from 'lodash';

let data: Object = {};

export const loadStrings = (strings: Object = {}) => {
  data = strings;
};

export const dumpStrings = (): Object => data;
export const getString = (key: string, label: string): string => _.get(data, key, label);
export const getStringElement = (
  key: string,
  label: string
): React.Element<'span'> => (
  // eslint-disable-next-line react/no-danger
  <span dangerouslySetInnerHTML={{ __html: getString(key, label) }} />
);
export { default as StringProvider } from './StringProvider';
